module.exports = __webpack_public_path__ + "static/media/SchoolsOverview-us.4c6cd303.png";